[
  {
    "id": 1,
    "name": "mascot's flower",
    "trim": "",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmezXCiEHuiXhim6xUyHLr1cShc7oNFqEw7qeBjEvnKkqr"
  },
  {
    "id": 2,
    "name": "mascot's flower",
    "trim": "holographic",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmV3CREGCeQFjcpYdZDtACuZbviZjNzsT69V9AQRQMqJRb"
  },
  {
    "id": 3,
    "name": "mascot's flower",
    "trim": "gold",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWbNTSjh2Zp1gYfx1CMaT4Zu7kDrGsQCUatUZtnM7ESmZ"
  },
  {
    "id": 4,
    "name": "universe mascot's flower",
    "trim": "",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmS1uT67rXBm8UYy4B6DEWCQzmxttLxQoSbY85aH8To2ve"
  },
  {
    "id": 5,
    "name": "bubblegum mascot's flower",
    "trim": "",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZypNyTg1J6H9J6ogYoxtjTtbfCPsReHGLohLhareeoWb"
  },
  {
    "id": 6,
    "name": "rainbowpuke splatter mascot's sweater",
    "trim": "",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSRHZ21DVZ7FjxK3Cwkn6niG3BpdDheiUEN3UspdNHi7s"
  },
  {
    "id": 7,
    "name": "mascot's sweater",
    "trim": "holographic",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmajduiqoWTUzvCSpALzJsyP3aVaGceD3ogZ6jvrjhyxD6"
  },
  {
    "id": 8,
    "name": "mascot's sweater",
    "trim": "gold",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPxRjs16qKmG1ru692TSz3Y3KEZM8KZhdtYXksesJra1e"
  },
  {
    "id": 9,
    "name": "universe mascot's sweater",
    "trim": "",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmXXD2UfhFckydQhug1f1b5nb2pSUbp3RJtWQogQUL9i3V"
  },
  {
    "id": 10,
    "name": "bubblegum mascot's sweater",
    "trim": "",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmbajqWgRrXgMbx26FQJqqWD5Pws8AZiwAkWZ24A6FqYUU"
  },
  {
    "id": 11,
    "name": "alien's toy saucer",
    "trim": "purple",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmVJjVz3yT41epBLsaQCvkjNuywKLhuPCgpdgK6ok6WtUg"
  },
  {
    "id": 12,
    "name": "alien's toy saucer",
    "trim": "pink",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmaB9UGoGp7HPcrtuRhqFDgvB5t4GRWvMqsuUdKs2oyUsD"
  },
  {
    "id": 13,
    "name": "alien's toy saucer",
    "trim": "holographic",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmchcFuPVNzkQAZV5R6zuYK5LfUnTfh6ZJ3Yfm7FpnmUUD"
  },
  {
    "id": 14,
    "name": "alien's toy saucer",
    "trim": "grey",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZe298TT5sJjZCs8Q1m5wqz82iSjnvAiMZa7HbdoFd1pz"
  },
  {
    "id": 15,
    "name": "alien's toy saucer",
    "trim": "gold",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQpqsNFm97Wzh6jwAA4txKV9HqBuUty3ispuJw3JqBpyp"
  },
  {
    "id": 16,
    "name": "alien's toy saucer",
    "trim": "purple",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmaNzxgpGeToa7bnAy81H32EyUDvwdATDGersBb2J4gBgf"
  },
  {
    "id": 17,
    "name": "alien's toy saucer",
    "trim": "green",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmbxJeVoT6iddjMzgu2GkzaT3QjkdN1jxKmezbrSacxWa6"
  },
  {
    "id": 18,
    "name": "alien's toy saucer",
    "trim": "blue",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcKDssMqbY6yfaQHvrviNNobfhYS4zukqk8oPnaUnd4C9"
  },
  {
    "id": 19,
    "name": "alien's toy saucer",
    "trim": "gumball",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmNiP462StqDgDtrz8kMGdmGrpuPevzRGNq5RjcWnaoLRw"
  },
  {
    "id": 20,
    "name": "alien's toy saucer",
    "trim": "holographic",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdZDHFBNdb37EbVeRvXTNanhz5z69AAS6rP3UJccAyxK2"
  },
  {
    "id": 21,
    "name": "alien's puffer",
    "trim": "super nova",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmaFEcAQH7ohQJuhgkxDi12zwDVdSaF6BgMfKhxQEp6Yx9"
  },
  {
    "id": 22,
    "name": "alien's puffer",
    "trim": "pink",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmNpCSUGGUAXAgNDXNJAYeCwt7Yw3inoFUtiff4n4ph6qA"
  },
  {
    "id": 23,
    "name": "alien's puffer",
    "trim": "holographic",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmTRAgCE81wXRXxazRTsqgGTZCQdmrNVrgX7xi3fARbVAa"
  },
  {
    "id": 24,
    "name": "alien's puffer",
    "trim": "grey",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQH3vmvVhG83pM8LeRQ5BKfg5u5dNDvrN3swUewsALGhi"
  },
  {
    "id": 25,
    "name": "alien's puffer",
    "trim": "gold",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qme1FVX5inXQYBb1WAMvZeL1N5qqvsx6vACoPB8yQ2YUMr"
  },
  {
    "id": 26,
    "name": "alien's puffer",
    "trim": "purple",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcpuLavDSqk7tmqFSqu2kSWbUd3iBakURDPsdNQAzph64"
  },
  {
    "id": 27,
    "name": "alien's puffer",
    "trim": "green",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmNhTQQjGxmtvYakS1Zxqqcf4ch2NcvX2jR711kSqvpV1h"
  },
  {
    "id": 28,
    "name": "alien's puffer",
    "trim": "blue",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmNMenWLJihfdaqtkMjqJ6rZi7vVV6CAvwRcDAMgG1dQ5U"
  },
  {
    "id": 29,
    "name": "alien's puffer",
    "trim": "gumball",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYnaqZf6BtZnGkKsjLsXz4T2rWvaoLwT74MU37hUi3SgE"
  },
  {
    "id": 30,
    "name": "alien's puffer",
    "trim": "holographic",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYxR5Ng5E9rysxrnHMMSSF7fHFZJwg4dbgsgfF4NDsp2J"
  },
  {
    "id": 31,
    "name": "cat's hat",
    "trim": "white",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPhNyw1fjRJTbXiMuL27fNn7RCbjZMwF1G9fXp6Cfb1yT"
  },
  {
    "id": 32,
    "name": "cat's hat",
    "trim": "holographic",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmV9TEZMejpsJoXYryKJua7n3xpjih2zFnMG3vZaR5BryJ"
  },
  {
    "id": 33,
    "name": "cat's hat",
    "trim": "green",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmf84G2ipNkeR6uNgWtYxovQ7yDHhgzn7jbLLmVEdbiAq2"
  },
  {
    "id": 34,
    "name": "cat's hat",
    "trim": "red",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRWGEPoso2UxUrhGGzb8J3oGkVFcyHCqfXy336SZhQP17"
  },
  {
    "id": 35,
    "name": "cat's moccasins",
    "trim": "white",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmR2F73CMeLXWB6mur26KBMn88L2pqTMhk4T4reAtVASLV"
  },
  {
    "id": 36,
    "name": "cat's moccasins",
    "trim": "holographic",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmcwevtL7kBZakaSaUpPxC71tgAuY7gx9c1JZBSYi6Wso2"
  },
  {
    "id": 37,
    "name": "cat's moccasins",
    "trim": "green",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmVYa2kjGVvLnJHsYXfurHRxTWutuvwF12qi11m2sQLBga"
  },
  {
    "id": 38,
    "name": "cat's moccasins",
    "trim": "red",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmerVaco3RrYNEbmRVeYythj6ig47DHtRK53i6bqaJzc1e"
  },
  {
    "id": 39,
    "name": "skelly's ski mask",
    "trim": "purple",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZoW8tdZAWQRxncxyKdvDfogvgJxZYUzdd7JE6TkN6Am4"
  },
  {
    "id": 40,
    "name": "skelly's ski mask",
    "trim": "holographic",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQbXP5diLzYrtFt3fw6YRWNPboAV7n1FoEPh55unpVn8a"
  },
  {
    "id": 41,
    "name": "skelly's ski mask",
    "trim": "gold",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSQgEin5Zi72tooyMKYdH2tXWs5qwRY7TVypQtNMYntH8"
  },
  {
    "id": 42,
    "name": "skelly's white collar",
    "trim": "purple",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmf3hb7rw1DpPLb8X52DKFfa6qWF9tLFHc1WwgevyH74rf"
  },
  {
    "id": 43,
    "name": "skelly's white collar",
    "trim": "holographic",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmTZsKy6rmZsSe3Ja2AksxzQGs3vYjiAPzRY9Hghk5wiut"
  },
  {
    "id": 44,
    "name": "skelly's white collar",
    "trim": "gold",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmV5U5uFwvCJdEWLYSmJ4wYVBkBec5KzRc6QrD2fi6KDYV"
  },
  {
    "id": 45,
    "name": "ape's helmet",
    "trim": "",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQF38Yb6Z9eQ894YTspgGi5nodAcFWotDz1sFPeevW2V4"
  },
  {
    "id": 46,
    "name": "ape's helmet",
    "trim": "holographic",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdzcGH8Zh66xaQqe4spWxQyGQZzJU31m8sYnGpo5qs6zo"
  },
  {
    "id": 47,
    "name": "ape's helmet",
    "trim": "gold",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcpccHex9sxFjtK2RnXB7TtLsYJhNtZHhGBPN17rNNxLE"
  },
  {
    "id": 48,
    "name": "rainbowpuke jacket",
    "trim": "",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWamcDPvcttpa7h9cb8QBxdvXT7waxZQ8wCodm16npBEH"
  },
  {
    "id": 49,
    "name": "rainbowpuke joggers",
    "trim": "",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbLvCHahUqrATz2k1mWBGkySsbayAeWPrLzvEKHjL5FMg"
  },
  {
    "id": 50,
    "name": "hydro booster kicks",
    "trim": "",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmPMUhv26MGAjauVxTyQg8jsLWtnPKff41BCA4dWqDpSzZ"
  },
  {
    "id": 51,
    "name": "breakfast tee",
    "trim": "pink",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmccX4tpAmr25jGEbuBYTy9SUwkMxcoqXHMNhGuZ1tsQ7Z"
  },
  {
    "id": 52,
    "name": "breakfast tee",
    "trim": "sky blue",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmVvtXMvZ17ciS3rMzvt33gyXTdsejqaiwi5Dw4rUMWHYQ"
  },
  {
    "id": 53,
    "name": "breakfast tee",
    "trim": "purple",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdyP3fNhaeRaVneSfPZFsMnXVLe2JZmx6qob6pfHaztqk"
  },
  {
    "id": 54,
    "name": "coffee helmet",
    "trim": "",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcbyY8xJ9J5juWoEcoqBfNMwcb7q2j6mNvMDNY7LfP9oU"
  },
  {
    "id": 55,
    "name": "rainbow jetpack",
    "trim": "",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmeaJTJfuw4bAgxjSXRkiKPmHxQx5PrH3ASy5V3WNGyqTq"
  },
  {
    "id": 56,
    "name": "sundae backpack",
    "trim": "",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQu128Pdq45wugyLMVXD9WwxS3cJwXGQkPsz8kwbfXYcm"
  },
  {
    "id": 57,
    "name": "birthday shorts",
    "trim": "",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "multi",
    "layer": "",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmY5Pc9FSLehoGbbTqx9WG22N8bJryqYHsvjt2kJBriNTx"
  },
  {
    "id": 58,
    "name": "dino slides",
    "trim": "green",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmXVpmz5tNpcjpiWnoGyeinEhBteZ5gnRoJmDYjSxwQQyc"
  },
  {
    "id": 59,
    "name": "dino slides",
    "trim": "holographic",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmShzyfu5Bui6xbjkmKF6h52nWvT3S8HgpnBQ7TwDtboCd"
  },
  {
    "id": 60,
    "name": "dino slides",
    "trim": "navy blue",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdPhNpkqPCwECSf9vRNny2mkT6UQ1CnuvEAX6VdAWHyqY"
  },
  {
    "id": 61,
    "name": "boxing gloves",
    "trim": "holographic",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "hands",
    "layer": "override",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmcgyb43SopvWd8z112QP1PTaP8qUvX7B1pXNZ98c9GNMg"
  },
  {
    "id": 62,
    "name": "melting sweater",
    "trim": "pink",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYqYcRrZcHXfEzGE7wRdGPYNctcnp9TaeogngtB9KVrDR"
  },
  {
    "id": 63,
    "name": "melting sweater",
    "trim": "white",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSn3qPauqwYj3tFhLyZwivc5eD673an59btTaruefbDHt"
  },
  {
    "id": 64,
    "name": "deep sea dive helmet",
    "trim": "sky blue",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPPfsuUgx98VEiPVM886hi1nZGjxZQB5xwRQh1aBwjdfg"
  },
  {
    "id": 65,
    "name": "deep sea dive helmet",
    "trim": "purple",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdzoMd61mEjXJzecipK88kfWMf9st9wUxMgnDCTf3sHPt"
  },
  {
    "id": 66,
    "name": "deep sea dive helmet",
    "trim": "pink",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmasgWkMH9uBMvFkzhTDYQ9TjTBMBS33y2wFmTtHCsMFdL"
  },
  {
    "id": 67,
    "name": "daisy blouse",
    "trim": "",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmV9TM6w34Gn2eZWsEQUue9fEQybVbv67Ufb8btcbnyXeK"
  },
  {
    "id": 68,
    "name": "devil wings",
    "trim": "",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "back",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmTCCokbvdXCHW1pGAw5BPR5E1ZtTpF1xL8bncPy1Scao4"
  },
  {
    "id": 69,
    "name": "lit jacket",
    "trim": "",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWsmWy6avvdXzfBsnbkZGtY2zadD1wJhcpnfKqwftmRBk"
  },
  {
    "id": 70,
    "name": "pickle helmet",
    "trim": "",
    "set": "OG Wearables: Unique",
    "set_type": "Unique",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWMVYdYZKA3JMRcF3qnZsKhhYPT9yD14k9sfao5pJP2x3"
  },
  {
    "id": 71,
    "name": "crown",
    "trim": "gold",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmeQxrqgZcPYkUvbrsDLjCMzenkg7mQhdaTnwTarNUjur8"
  },
  {
    "id": 72,
    "name": "crown",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmav8HMsab7Mke6s3JziBh3bfcGxc2QMd3ygoxSyKLRFtx"
  },
  {
    "id": 73,
    "name": "halo",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWEuzAGwgE1SmmtSEJ2aXizGPxFwnmRfmRPv2C3LbuiYx"
  },
  {
    "id": 74,
    "name": "puffer",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWEWPSX2SSbkxmg2TuXgYC1811fMMKL62kKzHZgWVjdhw"
  },
  {
    "id": 75,
    "name": "puffer",
    "trim": "orange",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRMypPxP4PmpDARV7vPAfYGkeB7FK1v91LUiGwqLKhQ5H"
  },
  {
    "id": 76,
    "name": "puffer",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qma55zLo5moLPUxXuM9kFbPt36vTzWvZVi5FsidJ42h46k"
  },
  {
    "id": 77,
    "name": "puffer",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcF3MVcUoZXusJSMz553x9gMQG1psubxxjQ9AEyfbKdzM"
  },
  {
    "id": 78,
    "name": "puffer",
    "trim": "sky blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYYHSJuu6LSh6PJQNCyqaMTYZfXiky5psMxqry87uw1dT"
  },
  {
    "id": 79,
    "name": "puffer",
    "trim": "magic garden",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmamsfbSPmBCE3QuSaDWbsLB4gRAmaS5C9UpbuR9gTzNTy"
  },
  {
    "id": 80,
    "name": "puffer",
    "trim": "coastal classic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmUT3jMTZ8LMgXtBFbgdVVeu9z6fCqhjTm2QR4Et8joqiS"
  },
  {
    "id": 81,
    "name": "puffer",
    "trim": "tokyo pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmb71CQ4w53tp59r9L1wbh3rPDiACBiP47dE3WfyTUyDxF"
  },
  {
    "id": 82,
    "name": "striped sweater",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmaRXNXHTKyAUsJZ61GzsgerUCwc2AAUeJ46P5MwX6T8qJ"
  },
  {
    "id": 83,
    "name": "cap",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQjuLgu8Dwtk1Qs8w6UZ5wKFNKqDzxwcE3UM1k2qJu86o"
  },
  {
    "id": 84,
    "name": "bucket hat",
    "trim": "beige",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPSgyWccV7nBrxEBGXFSkuLUoWj1JSnGUFMTrqMHpSv7E"
  },
  {
    "id": 85,
    "name": "bucket hat",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZrbLkWiQpsSBwDUd1hr613YKyTjkbX3NtWP1SYKcbCNb"
  },
  {
    "id": 86,
    "name": "bucket hat",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcRuwEAyQzvS6YUJNsEwFnzj3SBoLref1qcPNC3xwWXnu"
  },
  {
    "id": 87,
    "name": "viking helmet",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQ5xmH6CaVxE73sZRub6GkaSGn6k8nRip6Sin1Gxnbn4K"
  },
  {
    "id": 88,
    "name": "hoodie",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmc6gEgVJHh567EFaohDZ5wxEeAkZAmf1LrxVGP374XzhK"
  },
  {
    "id": 89,
    "name": "hoodie",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPALDJn7W6s4L23mNGkU4vj9kZbDxvPpWaeE6JmCwNM1T"
  },
  {
    "id": 90,
    "name": "hoodie",
    "trim": "grey",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWSsB1sMK3YVwkVEDX9PmX1yqzsXX4QF13Y4RSYmHC96z"
  },
  {
    "id": 91,
    "name": "leopard hoodie",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQMCRkAXVL5uXBMXhCwUak1TsLdPfkEiBMFHrmRBWAewe"
  },
  {
    "id": 92,
    "name": "spotted hoodie",
    "trim": "rainbow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmV4XSVwUwHQuqYqY2PdKojbFww4mfswuHSLzPgbWzq9ip"
  },
  {
    "id": 93,
    "name": "sweater",
    "trim": "navy blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZ6xqTAjUVvbwJUzFDBUn2mQNyUnKMTkr3FjTvaLZumqd"
  },
  {
    "id": 94,
    "name": "sweater",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmVHqnmSYQjPxE1vaMtGvU7uyYwcf3koTE7H9n4tFHra9w"
  },
  {
    "id": 95,
    "name": "sweater",
    "trim": "rainbow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRQ22rP7dQptUnLb33nRReQYzZioTZn5KM8vF58pYdb2r"
  },
  {
    "id": 96,
    "name": "spotted sweater",
    "trim": "rainbow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWe4YSN9h9dYWaMV1saxzX4srvL2SK6Noi1v4Nx5iDaBx"
  },
  {
    "id": 97,
    "name": "lennon sunglasses",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmRAgL69j9qTRUC9Mr8XUZqSgdNmpK43jkkmMH4dU4A1oq"
  },
  {
    "id": 98,
    "name": "aviator sunglasses",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmThwGFzWndBA6tGN7wB3whyrVMeF9E3hoF3VjBfQoyAcL"
  },
  {
    "id": 99,
    "name": "goggles",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmXEMS4uYxhQSw3CmL41qYJijMpXNkmocoEHtSgRHvMVuj"
  },
  {
    "id": 100,
    "name": "western hat",
    "trim": "brown",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSP2qiDXACAeM8cmZDzcCnvPdPgbm4UuGyZy5mUYquqmS"
  },
  {
    "id": 101,
    "name": "toque",
    "trim": "sky blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmW8rzSWkboVz2qvmJsuLsRBcLReiBeSi7EpFvyk9zW4L5"
  },
  {
    "id": 102,
    "name": "toque",
    "trim": "gumball",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmUiUse1WsHTyA5Wp9ktVKNUtJYhx7dyHFK45FRNcZzsDz"
  },
  {
    "id": 103,
    "name": "toque",
    "trim": "magic garden",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmUucvktJqy6UVXNS4jLzLtV95BZM5FeHvdJ5RjTfkt4xa"
  },
  {
    "id": 104,
    "name": "puffer hoodie",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmP56M6sBy7r7N62amUHnZXWKbMyEWuWUqHSfTd7FGZYZ6"
  },
  {
    "id": 105,
    "name": "puffer hoodie",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcTEAHFvTFmMk7c5c8y9mypN2DPPixVevJQtmPyZvQthT"
  },
  {
    "id": 106,
    "name": "puffer hoodie",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmaBY9HTVKYKanhZcEVtPcCnof4WhqLbcjwk71smeRyohK"
  },
  {
    "id": 107,
    "name": "puffer hoodie",
    "trim": "tokyo pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmXgNWCFNnrryxTgysVZkURAL29fowqaQTQN4A2FRckgNN"
  },
  {
    "id": 108,
    "name": "puffer hoodie",
    "trim": "rainbow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmR4JyskTwSFQANGNbTE55HN3V3q4wD9nMEZbCVx2rcs6d"
  },
  {
    "id": 109,
    "name": "wizard hat",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmUUcyABkDoNQygaMs3XbpBzPeyvuUrkEbzafuQtsAYGbG"
  },
  {
    "id": 110,
    "name": "shield sunglasses",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmX1zDMJfBGQUPxKtBduR6B6G4co4zLFmshd2kyP2TAh6C"
  },
  {
    "id": 111,
    "name": "cobain sunglasses",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmNkTHG6yewzQHM5u3jxwHv8NM5ouSQhsWTwwtLxmLNVMz"
  },
  {
    "id": 112,
    "name": "3d sunglasses",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmXvPwL6QSWf25ZXqAFwzRi3uDbVhe7eCgJE1psY8njKHL"
  },
  {
    "id": 113,
    "name": "60s sunglasses",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmf6XRYSprLCE72Rf6Mp6CdPdsyanXGYtZMjrsJPw4Ytj9"
  },
  {
    "id": 114,
    "name": "sticky note",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRyVKzNYRPTu8Xicmt1787VrtQwUqQJTM3wF3VGmcyPaf"
  },
  {
    "id": 115,
    "name": "sticky note",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmbn8nBRPU2gbnREaX7hL6z7WsN28eeimAt3iViLy7pvEM"
  },
  {
    "id": 116,
    "name": "sticky note",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmNgXZCuvQM6HDmqNdzXRa4sHygbF1fVD6CiCwNmC5aL46"
  },
  {
    "id": 117,
    "name": "sticky note",
    "trim": "sky blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmbVXxyFCxdnF5QdtE4rGDZtQVaHTPBzcfCS2aMgkN7t8i"
  },
  {
    "id": 118,
    "name": "collared sweater",
    "trim": "orange",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmf7ZBWp5vrVy7Kf4kd4yE36daozYdAbT9Fdw74mr5tURu"
  },
  {
    "id": 119,
    "name": "collared sweater",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmY7JkgciTYssjnX3x3Nvm8RAvAMAqtww32hQuqznFrd4F"
  },
  {
    "id": 120,
    "name": "sports jacket",
    "trim": "tokyo pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcMNwC1X1PXFvA8pYuKfYb8q4JFh6Xhq3iM5zNx4gpnYm"
  },
  {
    "id": 121,
    "name": "sports jacket",
    "trim": "coastal classic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmVjzvfP67d8ThQFPd36yMngzLhbZxzeADFmBA5x8kCVfY"
  },
  {
    "id": 122,
    "name": "sports jacket",
    "trim": "gumball",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdoneQoS2tbCcczcTANe8DANfcanYhEPqda6zLiqmZPPW"
  },
  {
    "id": 123,
    "name": "starry bandana",
    "trim": "red",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmccGUcziZc4NaV8YVFU6fFPvvXbztsZXRh21zMhVsQs9P"
  },
  {
    "id": 124,
    "name": "hoop earring",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZJ9HChP7vWzZPTZRdqKhcFa2dAfAQnSFCKhZWhGSxYHL"
  },
  {
    "id": 125,
    "name": "stud earring",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmeF4PjUk4KXJXecuhboh81kBz3DfGstYGQKvFUTCMDz6x"
  },
  {
    "id": 126,
    "name": "poopie hat",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmNfnCB8H4kJGZbpzCGkfs8rAUN4XQAaeGuGo1Z8UGhoDX"
  },
  {
    "id": 127,
    "name": "poopie hat",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmdrd8QfJ6hFE94sj97uH4Cq94C8pR6LSctN78pjnJ58zh"
  },
  {
    "id": 128,
    "name": "cap",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPUX28UVPkSZVzt7pKq1cMGTD4SMUENphVJcYewXkzcCe"
  },
  {
    "id": 129,
    "name": "harley hat",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmaeARXZPZZ8AU35mxAer3uGW63LvGBMmXAMgYKH5ba4zm"
  },
  {
    "id": 130,
    "name": "admiral hat",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPp9HBwYogNkm3zGTv9uyLB3b99zEGm4BH8z8CnxQyUz6"
  },
  {
    "id": 131,
    "name": "fleece jacket",
    "trim": "sky blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWR4gbwYeuDioYBswYTeTzURAWyxoX6ZKmERijsrvzCjh"
  },
  {
    "id": 132,
    "name": "fleece jacket",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmXDKVATbCKGRXU9ivGe3FWas9eBgSKP6qXc85Kytv5yff"
  },
  {
    "id": 133,
    "name": "turtleneck",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmVrvVLe9i5A9YJvB7yE9Mc6sXpmCWTX5Kdyixo1WjpemP"
  },
  {
    "id": 134,
    "name": "turtleneck",
    "trim": "navy blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdVvPcforrS2bfi7MdnJK7o3j4AoqR146Lhcy5UThtMGd"
  },
  {
    "id": 135,
    "name": "turtleneck",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmTpfoG1JRwcSBjuiAzJz5FDrKpNFUe7hC359nGqWcRRuY"
  },
  {
    "id": 136,
    "name": "helmet",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcvVeifhvyafmxtSd7CV26xU3JPf2VaqBj6Xav58TgTio"
  },
  {
    "id": 137,
    "name": "skully mask",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSRyDP3ozRnguRhjPqqK2UAj2yifPQEfiCkmcf6xHFQhi"
  },
  {
    "id": 138,
    "name": "headband",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmbNHmtm8PxrU5YA33Z9teFdF9sPFCeLoiR6JcaoN64avG"
  },
  {
    "id": 139,
    "name": "verified mask",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmX1fWREgAmJrXivtHrzEtYmQTK8CgzyPmEMyhjFe5iita"
  },
  {
    "id": 140,
    "name": "pods",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "ears",
    "layer": "mid layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmPS43ktk9YBegKCKYjid3JAsZKzyMJ7gkpLfqVi8vhwMU"
  },
  {
    "id": 141,
    "name": "hooded windbreaker",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmcw4oUMcarsbJUxPUeX2Ye4Tg8ir51fFHPU8xAefEmQRS"
  },
  {
    "id": 142,
    "name": "backpack",
    "trim": "sky blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZM8n38utE2kpRZ8zeRfxFwE1Z5c7qsndZhnmQANhKVav"
  },
  {
    "id": 143,
    "name": "hooded windbreaker",
    "trim": "orange",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmNgpvNLKh3VWBrvi741NdEbVoMt4q8NYCbbNE5X4kJDbA"
  },
  {
    "id": 144,
    "name": "backpack",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdwUWZf7sVeaUu2UfsjQkhQ5HhdWJevLoReCCAYNsvqx2"
  },
  {
    "id": 145,
    "name": "hooded windbreaker",
    "trim": "coastal classic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcFWt8iqcGuugxVWBDHDnPf3ukeKGCLJCCDh8V8dMgWD4"
  },
  {
    "id": 146,
    "name": "backpack",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQvBxq2wzr2aga1qB99J9MRVEkwKagqmQinUzf8kCNbaD"
  },
  {
    "id": 147,
    "name": "collared shirt",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmbuXX5UmrzaVZSfdk9sVdXNpMHSyfiqQUdYVBukQtUDTb"
  },
  {
    "id": 148,
    "name": "blazer",
    "trim": "navy blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmbpUyYGtkvQArDfXr4q3oiNusND1w3ZtMbUfnHg9Vmz1E"
  },
  {
    "id": 149,
    "name": "blazer",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWhoP4LF4dthcfcebumLchZRdrGQ271gSPMvhvt1XcYdb"
  },
  {
    "id": 150,
    "name": "sweater",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmaknaftP86RwTHSmMx35pyfVdVxA7GKnY4TKHpu8GYzEP"
  },
  {
    "id": 151,
    "name": "satchel",
    "trim": "beige",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdAHcNXJLJnv8e4J7iiwNtgHkjGpf8qp94MKWNtWrjkvD"
  },
  {
    "id": 152,
    "name": "sweater",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmXiK8x3w6pJvL34V9snUMdNSEEzhwcDvzguHJbXcBBnQd"
  },
  {
    "id": 153,
    "name": "satchel",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmTbowsKDSmjWEawszrcwWuxaPW8TMBpbfxvFzBTixqhW2"
  },
  {
    "id": 154,
    "name": "crewneck sweater",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQeHtyC2oM7cdxhgRNG3WZZmCPxV6EmaZwyewjKQJRmTW"
  },
  {
    "id": 155,
    "name": "chain",
    "trim": "gold",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmaDWeeyQFCk4Vj4K5HUhpkACAsDVPKM3w9wrvUZwHmsQ3"
  },
  {
    "id": 156,
    "name": "crewneck sweater",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWFBjnZVCVHaM1AKTofEnVKcL6qmdzm29guftpSd7thWu"
  },
  {
    "id": 157,
    "name": "chain",
    "trim": "white gold",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "chest",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmVSkBAuQvD9KPLbMcpJCpr4SmrDh9J2SbgXUFQgWhiwNN"
  },
  {
    "id": 158,
    "name": "puffer joggers",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZB5VxmZr49iPBVwJf48tm1BTjQNptf22bMJmGnzLwF2k"
  },
  {
    "id": 159,
    "name": "puffer joggers",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdRT9vx6Xz62o39YYhYgiWpzVgcFz3Q7ArqV43cgG8k56"
  },
  {
    "id": 160,
    "name": "puffer joggers",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmd2tRfbJxPVXDWrGieYqtQWQAsz7yPygLVrVq6wLktLyo"
  },
  {
    "id": 161,
    "name": "puffer joggers",
    "trim": "tokyo pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmafQfVkTU4QgYwufysxDqm1oK2SDXFGLdFwKoQCoJQNUG"
  },
  {
    "id": 162,
    "name": "puffer joggers",
    "trim": "rainbow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmcShi1xWYciGQGgWTmAzMiEv1daP7wBktmBwheqZ7gYq7"
  },
  {
    "id": 163,
    "name": "gym shorts",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmRLM4oaMkf3LDaLwtAhRazeFhSp4eFX15idE7Ut2iwuSv"
  },
  {
    "id": 164,
    "name": "gym shorts",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZ5DbbY6G1Ze8FwdTQd92hvHFXoiFjsgspqzi9xGDxYkV"
  },
  {
    "id": 165,
    "name": "sports shorts",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmb9gRZL4AU5uX1EYHyN8CTuE36DeByhsXNDb2apAGh2x7"
  },
  {
    "id": 166,
    "name": "shorts",
    "trim": "orange",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUpXzNP5TjD3n7JB1vteS8fAsAWVongG8DiAecitPgB7e"
  },
  {
    "id": 167,
    "name": "sports shorts",
    "trim": "navy blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmXJ4VZY6n4MiWQ1ASW8BHm4q95aAzCzq1ZRBgHXdVXWbX"
  },
  {
    "id": 168,
    "name": "spotted shorts",
    "trim": "rainbow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdVxAd6D45CepCmsD19umm6Ztyz5nZR1KmWFdqkheBAyc"
  },
  {
    "id": 169,
    "name": "skirt",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWaTxKpwpSZYnYXapA98bSFymWBPwi6QYMZXWRTjRZA4D"
  },
  {
    "id": 170,
    "name": "skirt",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmW7ooTKoakEbyEUdVtsAxjHYh7cieKKBvH7TuucTZwm3Y"
  },
  {
    "id": 171,
    "name": "shorts",
    "trim": "rainbow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdD42nF6zeFVGPcZ6bdVEFjPhcGZkVnbtbcJEMNZZTrUS"
  },
  {
    "id": 172,
    "name": "touch grass trousers",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmV6J9HjDBVY6GvopwUffmHuoQ8s1iZ2azgudtXbL5u7De"
  },
  {
    "id": 173,
    "name": "touch grass trousers",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUxMVugrDkaKKGErdSBgNUaaCL1m2woFSSBRGMFtAXXyD"
  },
  {
    "id": 174,
    "name": "verified shorts",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmctBCWuMpzQirJ78tUcrzB3nM6uohWzoxbPCxLJwaVdLF"
  },
  {
    "id": 175,
    "name": "lint pants",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmNuRtmYN8r6eaAAQfSbVfs3iLxHo1JNqAY9xNct4kyD7q"
  },
  {
    "id": 176,
    "name": "bees wax trousers",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmacPwKJz8RcNg7Q6dLKJhm4Vwhw83xFigysKi37qR6vCx"
  },
  {
    "id": 177,
    "name": "joggers",
    "trim": "grey",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmWMVPxN1vvEQvG7fBVY2jPRgjxyKAXVHjZ7L79BjZupv7"
  },
  {
    "id": 178,
    "name": "athletic joggers",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmT3rqNZQT9UBSYrDGbDHsW37E6TYEbjV58T6xQtRFPVHx"
  },
  {
    "id": 179,
    "name": "cargo pants",
    "trim": "brown",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUoWBnApuJbv9eSBq3rkZPAqd3tZbzBsDXLLsmY8Wdgp6"
  },
  {
    "id": 180,
    "name": "sweatpants",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmYtkkdUR6N8avYUri34E8zhPmKfzWhw7J1mPgJJaNruJW"
  },
  {
    "id": 181,
    "name": "leopard joggers",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmdj1FYp4ddSwycmWyiUcVxGCeA3fB1jx41eHqDynr3soa"
  },
  {
    "id": 182,
    "name": "leopard joggers",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmXqHQwkYVqV1stAciQTFuRD6qfZMs5qGcsm9WPuy2s6x2"
  },
  {
    "id": 183,
    "name": "athletic joggers",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmXDk2LatgZffvqVP1gxucF9FKx2cS7TWYR7eE4oNPQuCk"
  },
  {
    "id": 184,
    "name": "athletic joggers",
    "trim": "sky blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmVxTaJJqjC1Mgt63FFubnrYjxEHamZprjSH4JeFvfr6aF"
  },
  {
    "id": 185,
    "name": "sweatpants",
    "trim": "navy blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmcFG9g5gwNX6VtVyYJkAhkf2siqAyjLQ4Gyw4GDmNZ1z7"
  },
  {
    "id": 186,
    "name": "starry yoga pants",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmaC5u1uTYd58GeqaqoYrhbZwo7CqS9PXkm8wziJURdeGN"
  },
  {
    "id": 187,
    "name": "sweatpants",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmURMC5aEyLHWpWmbbgHtakSfy87RMgvsY7afWmRDHQE1f"
  },
  {
    "id": 188,
    "name": "sweatpants",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmYqerT7YjUsGYF4VHNG2k7X1QiuJ2gpJ3iDGt99YNFz6Y"
  },
  {
    "id": 189,
    "name": "chain wallet jeans",
    "trim": "blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZFu61XnsceDogYTzG2YhcTqysmL8Q7SicbAqK23Tu1qM"
  },
  {
    "id": 190,
    "name": "chain wallet jeans",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmf1jeVHcRtLHi53nMYM4p9ZCQXdGC3LBByf2oP9hadv3X"
  },
  {
    "id": 191,
    "name": "chain wallet jeans",
    "trim": "grey",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmd5Afurhr4cryUC9RVP7tAg9EkTVkPC25AvSJc8eTSGuk"
  },
  {
    "id": 192,
    "name": "cargo shorts",
    "trim": "brown",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdSxyjkboroXCbjAtWNLEQfNsAtmZhKHf2uyKhrZu9gpo"
  },
  {
    "id": 193,
    "name": "blockchain pants",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmTmFcwMsukieUfBDgRhLrUkTPtaH44RYFoyAHGbSkMi2j"
  },
  {
    "id": 194,
    "name": "sport shorts",
    "trim": "grey",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmQRmeGPLZdZs5yc5SMfQPdqUWPL1Suk4KpxjrTJuRRMHw"
  },
  {
    "id": 195,
    "name": "color crew socks",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmc7XoqxVW71Aqioq4JzzAjCbsSdUFSdxswQJjPeiVN8jm"
  },
  {
    "id": 196,
    "name": "color crew socks",
    "trim": "sky blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmdek95JZjVKrJvQsjtksLKc257zjM4BKNLvk4iVYznKYc"
  },
  {
    "id": 197,
    "name": "crew socks",
    "trim": "rainbow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUbvBB8wydbxe7RasdTxAbBULXCCEVntf4dxHwb12dNqR"
  },
  {
    "id": 198,
    "name": "crew socks",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZZuvKp6HXXFw2wnHmSi6Qy1skpuy1odxuEgMfKL5wRoB"
  },
  {
    "id": 199,
    "name": "color crew socks",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmNUHYLwpsPMSUomF4MoTBBEuSE27qK3kAtbb3MxkbtBbk"
  },
  {
    "id": 200,
    "name": "color crew socks",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmYKny8JNcdDuBg1Bgr2xyjSXbQA7WdWQjhUxeD51G5hFw"
  },
  {
    "id": 201,
    "name": "color crew socks",
    "trim": "orange",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmYhtpHnaDV9puUoV9sW5LUuJcwDdphv6FQrP2De2iyctQ"
  },
  {
    "id": 202,
    "name": "color crew socks",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUnYXfghwYGuBVAb5gsN5ks1dEvRJFhd8pydoHsx5EfGF"
  },
  {
    "id": 203,
    "name": "crew socks",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmassoxqUhLPg6iogp2G4qLGRR2E7KqxYd64LtZhLChAeu"
  },
  {
    "id": 204,
    "name": "color crew socks",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmb1zAWZ4Wr14B9iJ2agzydGUwseEP2w6KKohvMo5pxivb"
  },
  {
    "id": 205,
    "name": "crew socks",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmSwC7TcjP4ki1xT5ZjotwdYQC5iKQeT6d2xasei23xVMM"
  },
  {
    "id": 206,
    "name": "crew socks",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbENcpTLJdVDEvg2uqzLZCDYdA2MqEMF5fu1N7UoRDGJR"
  },
  {
    "id": 207,
    "name": "rollerblades",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmcSgtd8qQRoUiULU1Zk3FZDM3oat1QxzeAFRJSx8wKZZt"
  },
  {
    "id": 208,
    "name": "booster kicks",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmS85w5DJJLG5jC9DTimqE9Sicmz1xWUwTfvsiM2aK6wQM"
  },
  {
    "id": 209,
    "name": "booster kicks",
    "trim": "rainbow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmQ8pRy1bSt8oxbxVuQCHqm69osErTfU4Bu3UgiHjkZBMz"
  },
  {
    "id": 210,
    "name": "checkered slip-on",
    "trim": "grey",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmey5ompvDX6pGrmDNKydcoeHRcwk8XBVpKptYEnBewEUL"
  },
  {
    "id": 211,
    "name": "checkered slip-on",
    "trim": "rainbow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbUt1WQ19L2qKkaPxi4dZehJTGBuvpE8DKYpsNkZqvNMg"
  },
  {
    "id": 212,
    "name": "shoe",
    "trim": "white",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmd9Yc7XbWs9Rw3z3Vch2KQojdmLTZqt9gpuCMrwAfk732"
  },
  {
    "id": 213,
    "name": "shoe",
    "trim": "navy blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmVHeXd3DWQpQAS7fdjnNj6yqmCuPKi1Qieq2D49KWT6UN"
  },
  {
    "id": 214,
    "name": "shoe",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdufmA3BX714LcmPTETHcNyfsjYWkUjmEQEL1RMyUKcMo"
  },
  {
    "id": 215,
    "name": "shoe",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qme4NfxLxkyUjUnifDaHZy7Uw3BHX4Ju5153rCLmFFSBxa"
  },
  {
    "id": 216,
    "name": "shoe",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmfH4PgRmkr7EnDN1WSETZGRgWEvDGh2LQLCY3SgfE2ZJk"
  },
  {
    "id": 217,
    "name": "shoe",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmWCLUkzsqFvaRbCCxShcGBCKDxB7Va1gwbcmVUfmqS88f"
  },
  {
    "id": 218,
    "name": "shoe",
    "trim": "sky blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmVTxxQ3irfq3E7LbwcHGa5MqEKPxcy3ppGQNa6J41Fuua"
  },
  {
    "id": 219,
    "name": "shoe",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmcrKX5FLsfryZA2yEvDKg4eEajJtN8395sT7H2oGgjkuG"
  },
  {
    "id": 220,
    "name": "slides",
    "trim": "sky blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZNdzGHcvRRtToL2isu2SVLY1QqyFwxzJA5BEcHDUpzhp"
  },
  {
    "id": 221,
    "name": "slides",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmNkjCNfTnQW9i166WFjRXd5cfQuKoCwifEvpYoM7fqR3R"
  },
  {
    "id": 222,
    "name": "slides",
    "trim": "orange",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmTJh9Lqnv8NgNrth7d1syzU8dcrfKEB1smFowXo5vPU18"
  },
  {
    "id": 223,
    "name": "slides",
    "trim": "navy blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUcbyTqbsmdUb1GCcbNxvEc1oAh9tZnHoKBymatWJiCmU"
  },
  {
    "id": 224,
    "name": "slides",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmV6XigMsdf9WeyMhivUghFR99Y9UUW48PojmZTHTuaPWk"
  },
  {
    "id": 225,
    "name": "slides",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmY8vhgMzzLbJyu8birjfHimVgPLBSGZEjegJ3kE2gMxba"
  },
  {
    "id": 226,
    "name": "bear shoes",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdRqmvZ5Cv4NSC1j4ZioCx39HmGNAcVoZsvgMVy4mZzGg"
  },
  {
    "id": 227,
    "name": "bunny shoes",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZsUwTWFfpuQJJ2mqqyaupR6FG1NUC5eN3DWVAKqt7ZiC"
  },
  {
    "id": 228,
    "name": "bunny shoes",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmaWKTroSacLBsuPeju2tk4UPkSoFg5qVXjW6bn7NFu3Y5"
  },
  {
    "id": 229,
    "name": "happy high tops",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmXyAnRkeSUcMP8u54UVaieCmn3vKbE2LVccSctPmrhXQ9"
  },
  {
    "id": 230,
    "name": "happy high tops",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmNwf2H1UpB4Fx3Pg2o5WpXLYdSTvejxuc6CJjC1MGEoSA"
  },
  {
    "id": 231,
    "name": "happy high tops",
    "trim": "navy blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUS2dVZZ3FeVh7Nnw3tKnG5hVhDmJw3X7JZWcmwmo9CH3"
  },
  {
    "id": 232,
    "name": "basketball shoes",
    "trim": "green",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmTNFe4g1ABR2usF1NiN9mwUbyyPC7dk33NVRg2uY2H5oz"
  },
  {
    "id": 233,
    "name": "basketball shoes",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmcy4detMgCXmYbv3FbKKbcac5AsZaatU5XgUy39Jsdtit"
  },
  {
    "id": 234,
    "name": "western boots",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbS59gnqifK32HVmXnVaJZntkNXq1dJh7pXEvvSgsAuj4"
  },
  {
    "id": 235,
    "name": "western boots",
    "trim": "brown",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qme3r2UD1gNDntj5KoXjtsL6s1Lr35JtC2ifccZxmkVjUx"
  },
  {
    "id": 236,
    "name": "chunky boots",
    "trim": "yellow",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmSRCiyiatwWTEbFQA688o1pcSN7TA83JqWyNw67AR16fb"
  },
  {
    "id": 237,
    "name": "chunky boots",
    "trim": "pink",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmVov8SHg8SEFy5xpZgPJcSRsX2fB1nCoPjTP9ZB4paSmE"
  },
  {
    "id": 238,
    "name": "formal loafers",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZzp7rpY4GEi4d3TJ5vzBY1tmbEXkL5jCAjqgRJFJxHHC"
  },
  {
    "id": 239,
    "name": "formal loafers",
    "trim": "grey",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmRnFeko1qCWwv1GVCLmTHNRNNpjD76sNnqk8NGEKnUikb"
  },
  {
    "id": 240,
    "name": "formal loafers",
    "trim": "sky blue",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmT2h8g2xPuCPefpMrrSBpnnQCpGfKk7QwSSYoy3hJVQZ2"
  },
  {
    "id": 241,
    "name": "sneakers",
    "trim": "",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmPNcXTbWAKcv22LmzwHPcA14QHeS2r61vjjW3Z9zWPEqx"
  },
  {
    "id": 242,
    "name": "sneakers",
    "trim": "holographic",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmTUMSiP5uXak9zA2VnxSTTERETk4Non4goC3vX5KfoBkW"
  },
  {
    "id": 243,
    "name": "utility boots",
    "trim": "purple",
    "set": "OG Wearables: Core",
    "set_type": "Core",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmSuLMgmiWK5rdHnp1trquZZP5ouTX3QHFVTBQyCBMeBaw"
  },
  {
    "id": 244,
    "name": "beta pass",
    "trim": "",
    "set": "Doodlebot",
    "set_type": "Utility",
    "body_position": "",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmdsq27zMFJiZiertMg5nAJp9mbS9sRKhDYo1kPgfFwhdM"
  },
  {
    "id": 245,
    "name": "color crew socks",
    "trim": "gold",
    "set": "OG Wearables: Custom",
    "set_type": "Custom",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmSpmBbxcDFK23YJqASL2PtsrpLCesxVZfw9nQG1cp7Tjg"
  },
  {
    "id": 244,
    "name": "beta pass",
    "trim": "",
    "set": "Doodlebot",
    "set_type": "Utility",
    "body_position": "",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmdsq27zMFJiZiertMg5nAJp9mbS9sRKhDYo1kPgfFwhdM"
  },
  {
    "id": 246,
    "name": "starry bandana",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRzgRXagviGCFQZK12iZ442RjUxV53kQttmHRSf4uQFsS"
  },
  {
    "id": 247,
    "name": "starry bedsheet cape",
    "trim": "red",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmb8moGzcXK2PbCn9cZieXw9Yhi8Atug5rft4MshDyEWCC"
  },
  {
    "id": 248,
    "name": "heart emote",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQZLREjpKKSUqjqAMBPDqATXwPZR2Wrynj1w6JX33r6AT"
  },
  {
    "id": 249,
    "name": "portal face",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmUSTNeCxvM1KPvTXCLXXUr1A7zC6qaxPFqVthMDovk7ke"
  },
  {
    "id": 250,
    "name": "fairy wings",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmPq8JzhXKwrYTLtwZ42ecQFSQPUCL7dn92icdeQb5Js1o"
  },
  {
    "id": 251,
    "name": "touch grass boa",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmW43Yv8pS7Jv1MLahNowrppEztgNMbHEN99pv4iwm8wrB"
  },
  {
    "id": 252,
    "name": "cucumber headphones",
    "trim": "green",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmSR7ZCVWcDfBSYqWRp4nWsaD6EpBmLoiYs9ochysymNpV"
  },
  {
    "id": 253,
    "name": "condiment jetpack",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSRsknCBHrJ4CAtq6zEMEBwN6BYARpgrrmdQmL7qMi862"
  },
  {
    "id": 254,
    "name": "over-ear headphones",
    "trim": "fiesta",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmcCJ4wXJyYC1z7PsM8aSVqehdZqG3ucciG4uFeSaDVWE5"
  },
  {
    "id": 255,
    "name": "verified headphones",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdAKDSTPy93FJH3WkuCUStfUy9ha2cy75njD9X8frUM2M"
  },
  {
    "id": 256,
    "name": "skelly bandana",
    "trim": "black",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRzF6zpH6on3kYj9pTiA47NUQq9mpzbKjapnZ7pbwVDpU"
  },
  {
    "id": 257,
    "name": "starry bandana",
    "trim": "black",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRMBAQYt363vZhnzRAS3gUxuLdvnfChmeeaoWimfBuZyv"
  },
  {
    "id": 258,
    "name": "alien's headphones",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdJsxHdFgG3xtZvP4Vi5spuggbnRTapcBv6jFgowo5md6"
  },
  {
    "id": 259,
    "name": "star glasses",
    "trim": "gold",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmWgcBfMKVTPBA5Zn7e4a9wuq13jgcE5tApqj6h1te4skG"
  },
  {
    "id": 260,
    "name": "holographic jetpack",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYQB441ekmr8TDCyzjZozUPcr8DeDuwFWgLnVtmDnVV9u"
  },
  {
    "id": 261,
    "name": "hydro jetpack",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcTfWzXHSUhHQq42x1vFCC3yzy9Xzyo63PjJCAn7zvGWZ"
  },
  {
    "id": 262,
    "name": "wrestler's glasses",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmYLbhxLVrKpX4j3NibxPrBNdWkBtSnGoz17TVqwjyVPQz"
  },
  {
    "id": 263,
    "name": "butterfly",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQ5F7rcM97dt7WeBFJSZsBjvrdVmhFTZhNvooWBrQxnaq"
  },
  {
    "id": 264,
    "name": "fuzzy-friend earmuffs",
    "trim": "yellow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmVMsMe5AVaBGtMzEDLiM7CSgfXFvFCRZGZG4cTJjABR1u"
  },
  {
    "id": 265,
    "name": "fuzzy-friend earmuffs",
    "trim": "green",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUj8477FKL6GHhcrSReRYFDo4tcf1J3a8P6jdXhzBJ4or"
  },
  {
    "id": 266,
    "name": "slim watch",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "arm",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZu3jaLr1a2kC5GUS5G9nUHfQRiLfuQQN2qg24xzJ8LKP"
  },
  {
    "id": 267,
    "name": "fancy rings",
    "trim": "gold",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "fingers",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbU3jC2swk92TfG2ezWHszw2V4adQFBDQb4nBbyEFWevH"
  },
  {
    "id": 268,
    "name": "sling case",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYQJMDQRysSGzoH36Pv9EuR2E2xkQGu5Dvy3AcEUtPuiV"
  },
  {
    "id": 269,
    "name": "over-ear headphones",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmRDdQuiuqFfXCC6TcLtGh8wWwL1uPQsGZLt9ioGD4XFpK"
  },
  {
    "id": 270,
    "name": "heart glasses",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmTDeFrTRaVgWT3URe36EUyBWuNe5JmPkk2a8ajCctSMr7"
  },
  {
    "id": 271,
    "name": "poet glasses",
    "trim": "black",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbxsJ12v2qrfTDTv1XZzWsF8eBjS8gP8CrFadYdjiU4Gi"
  },
  {
    "id": 272,
    "name": "far-out glasses",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmevjdcEyGwrHs9hnw7gexwfaBc4LKHapEU5b7scPDw973"
  },
  {
    "id": 273,
    "name": "worm",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "scene",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPF5mcSopZFg7ADhbc7eamLVrhKZsFE4ioFbQVrkqB4wD"
  },
  {
    "id": 274,
    "name": "on-ear headphones",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmaggvJwqhFQnbXXN2hBAdoFgSz93ko78kdmVjhpQB1rfX"
  },
  {
    "id": 275,
    "name": "on-ear headphones",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmRWhbPSR9A5GwPhyu1V5z1EK7cnsc3LcaaPCHsSwDYkQZ"
  },
  {
    "id": 276,
    "name": "slim shades",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmd9thLpsCvghYuzPgmx1yUUFS6tnr7KqWfWHd6gfzs3ju"
  },
  {
    "id": 277,
    "name": "double-piercings",
    "trim": "gold",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdvHQZijUcvGBgZGTC8TkepSBuCXSnhDFfE9fV52cwsmz"
  },
  {
    "id": 278,
    "name": "alchemist's goggles",
    "trim": "yellow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmfK3VFjF5CbaGVnHP5A6cFnE8P1WhAEjxqs3jKfhjEmYU"
  },
  {
    "id": 279,
    "name": "galaxy head",
    "trim": "multi-colored",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSJ4VfV2ttcyXP9EHS2HpPoWJNhZMAhQPfMJt7vaMBg2h"
  },
  {
    "id": 280,
    "name": "smart watch",
    "trim": "multi-colored",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "arm",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmUCk18n4CN3hJXzx2rJD3HvTRCsjYSiVysjGi1Z5dXnQd"
  },
  {
    "id": 281,
    "name": "pot head",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcRFQU9y62RB1oNpsvSHs9wEmZJ1nFM7cDV3QEwGqzZfb"
  },
  {
    "id": 282,
    "name": "pot head",
    "trim": "gold",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSX8pZLXhqYkThynT81LzpMsnqK8byJpDtxvh7rgMf2mG"
  },
  {
    "id": 283,
    "name": "daisy shades",
    "trim": "multi-colored",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmf1EVWT794r8vrxXqkK6fobfxsUBwYzMWogra4KUk5fa9"
  },
  {
    "id": 284,
    "name": "monocle",
    "trim": "gold",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmUS68rUuwPNCMpvTwFb5fn3FcEvGvdmuyrL6KCfww7tNY"
  },
  {
    "id": 285,
    "name": "breakfast headphones",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmRu9tKsy44m2M7sS7TohTXNUEGvF9b6D71vJXGHkYumye"
  },
  {
    "id": 286,
    "name": "bow tie",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZ87Z7Q9Ewr8qJqKoQesrpCAaHmCgJzh3d6abjVWc1BjY"
  },
  {
    "id": 287,
    "name": "bow tie",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmbGAMg5h9nH7fQDWVib6rQD57UXqxrcchgaehuB7AAZxE"
  },
  {
    "id": 288,
    "name": "diamond ring",
    "trim": "gold",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "finger",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmU4KuUTUZBGU1n4jc6BmN2kP5YxCdXnB17Fh7EJquW9WU"
  },
  {
    "id": 289,
    "name": "cyber phone",
    "trim": "tokyo pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "multi",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmc7ujMc6gpxeeLUMYze9YJS8TZxkLoajdSzh974YQJ9qu"
  },
  {
    "id": 290,
    "name": "fanny pack",
    "trim": "yellow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmTpKW4FHNyiNeErHYymwD5cqQm8o9BbwLXQHihumpyGYt"
  },
  {
    "id": 291,
    "name": "streamer headphones",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "ears",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmVhUoc5CZvs8WZaMX5B4WpbGgkH6LEUivL3rtD8UEcSGi"
  },
  {
    "id": 292,
    "name": "binoculars",
    "trim": "tokyo pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "accessory",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmWg4Qg64uu3uw9FqscZipmCjQnsX6gEDYMCrGN1muoYpH"
  },
  {
    "id": 293,
    "name": "wizard's wand",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "hand",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRsssF4j49qmC4Vi37JCpxhrDbuvX1wsEZwX2CNEJ5oQp"
  },
  {
    "id": 294,
    "name": "spa mask",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmaqUYgJSJ2apYdQtoxBARUEy3giwWnRiwGFBhyU4imQsu"
  },
  {
    "id": 295,
    "name": "pencil",
    "trim": "yellow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "ear",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmcff46m3F8t2V5DMcDGhhQx3DVoqZdkZJFQvgj2Zprhb6"
  },
  {
    "id": 296,
    "name": "toque",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmP9oX34MQnKZ1NwZ7PTb12zf8KYMGZkYrD15VZ99usE4d"
  },
  {
    "id": 297,
    "name": "runner's cap",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYeetnfGBYhHx43ehqZBX5BKG4qmktntQ5kDXXp5JbanJ"
  },
  {
    "id": 298,
    "name": "chicken head",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYAscTz6uAZectBMbKoTJcEuEFBxBXskekq8jbiLmWGTe"
  },
  {
    "id": 299,
    "name": "floppy beanie",
    "trim": "green",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmUrvNo99VE3YFL1CmYBxseJmUaHQ5p3h4s4Pxii5egR7T"
  },
  {
    "id": 300,
    "name": "floppy beanie",
    "trim": "black",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYiWpzhPMoWZQFG7zP8LnHhhjdpLfHSvfWQs7rDCEZNzu"
  },
  {
    "id": 301,
    "name": "floppy beanie",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmarD5dtE8GSCt2795ZiewjWiS9k8fCctPhfYcRNnqfNYh"
  },
  {
    "id": 302,
    "name": "egg head",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmXgRHJH1oPRiTaEHiVQCS2bw1MvfWW286n3DiQb7SVp7r"
  },
  {
    "id": 303,
    "name": "explorer's hat",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmctpBcLLdrSQRxdSZiHdb9ANQN1Ffk6zcTVYpWVkQJkLT"
  },
  {
    "id": 304,
    "name": "head in the clouds",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSV9DArKzZhQGSVfT8GJCquj8G8BksPEACHNi6TyTm99K"
  },
  {
    "id": 305,
    "name": "pigeon hood",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSSaSAQ5m3roDStbnQad6HWaVZ1gH5qX2ibEpr7zyiD5A"
  },
  {
    "id": 306,
    "name": "traffic cone",
    "trim": "orange",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmVN2utStsqgKJSXPuzT4picmzKGcKvV5Pdjg25CGpRzzM"
  },
  {
    "id": 307,
    "name": "spaghetti hat",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWtmibmtY3gJw4tiy2XsCVqgGKqjA6HDy7M1pCKzuR4dP"
  },
  {
    "id": 308,
    "name": "umbrella hat",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWfW6c5ffKmC3fp6zPa5HuRgb8HhG98xQV4cCsWGDkJyU"
  },
  {
    "id": 309,
    "name": "toaster head",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcLgL8ZvcsximgDLPf2y19ZHPvoaPm8CWLGfjZ7nteqMw"
  },
  {
    "id": 310,
    "name": "paper hat",
    "trim": "white",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmTZZHGVbeSUk6A7UNxoL2G2RTUXgAew1Z2wTj4sNhdG1i"
  },
  {
    "id": 311,
    "name": "fancy cactus hat",
    "trim": "green",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQatMHjKr3htaCgi4eZR3V7T4oNao2xbr8KimJBCpraBh"
  },
  {
    "id": 312,
    "name": "sundae hat",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRkkvb4WDq6oZcGY7XyKgj1YJMaFcuHPFLvamPBc9BNza"
  },
  {
    "id": 313,
    "name": "fish head",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcCCqoJkjgv4CXEovSo6St8QNPgCSVJBaihDUxzC38iuK"
  },
  {
    "id": 314,
    "name": "pollen head",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmR8XG86RMPhGGNtpos4hwHuei1BHgHtvvvbTx9fXVP45R"
  },
  {
    "id": 315,
    "name": "counting sheep",
    "trim": "multi-colored",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmXALJXxetns5FYDLUZZ97dPVB7GzxfpZfLPzLwWeR77MB"
  },
  {
    "id": 316,
    "name": "helicopter hat",
    "trim": "coastal classic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYw1QhrugvFsYXFQHURrLqsY4L2NPP3GSaRvLojjkQq4W"
  },
  {
    "id": 317,
    "name": "sippy cap",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdXpf2g2iGpKUWyzZLw3BayBgmump6FcHz8LQiKRRugRi"
  },
  {
    "id": 318,
    "name": "television head",
    "trim": "super nova",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmTzkUnngYJmGQGGRzpecWdE34GvNM3AajrTHLJnS3wb2j"
  },
  {
    "id": 319,
    "name": "backward cap",
    "trim": "fiesta",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcGJ18V7YuB9NwL1axuzUh8mhSCvXExWTgyvWukiDHXfG"
  },
  {
    "id": 320,
    "name": "fish bag",
    "trim": "orange",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZL5iv8EgwgYt1zqpwpZgMCHiUFrGWpG5bu14YgsMJi5N"
  },
  {
    "id": 321,
    "name": "fish bag",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmbAFdyZESoGM6oyca4bfguqaWL83MVnJVEZmNqJwzXSQX"
  },
  {
    "id": 322,
    "name": "shady head",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmaxRtq56Tst6oM6SmaDHroP7WhQXbGgFWNM1nJgZz8NmH"
  },
  {
    "id": 323,
    "name": "sudsy duck",
    "trim": "yellow",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmY4A1MkQLYe2ABR7Pwi9UkRDwxddHr5qJCV74m1oeZPBY"
  },
  {
    "id": 324,
    "name": "louise head scarf",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZ9ZPJeswxUDthfSaM1PhfZ7MP837NEVf2CNTC1qmHEV9"
  },
  {
    "id": 325,
    "name": "moto helmet",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmbc9SNeKwxxQBXRkpC8NM6obynBiok5mwnn32yi4UeRdU"
  },
  {
    "id": 326,
    "name": "puffball beanie",
    "trim": "coastal classic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRaC2Sk7KD93HHRXVyzBr8JhRZDAKHK3uVuxReQXBxHRA"
  },
  {
    "id": 327,
    "name": "sock puppet head",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSWVpUG4BRSAv6uR4xjngkSTvpCuD6nNAgW6EPUM9uVAx"
  },
  {
    "id": 328,
    "name": "birds nest",
    "trim": "brown",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmTyQ5MjMXNyfz3cLbX8Puw9RYQYqmuQniR5vwu2hZLGrW"
  },
  {
    "id": 329,
    "name": "double birds nest",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmU6xYxyTTxEcTgde55rSZr5tWjx7zgK7QKs21EjpuoPgk"
  },
  {
    "id": 330,
    "name": "brainbot headpiece",
    "trim": "brown",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmX51Mfk5HnqFimg59yzVQ8y336cRfKdoqU18pCA7JjVMW"
  },
  {
    "id": 331,
    "name": "sleeping cap",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWdHQ4EgMErGwWoqriWYktSyc94fMpokUxjSfH5pwVVEb"
  },
  {
    "id": 332,
    "name": "fuzzy cap",
    "trim": "magic garden",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYcchGr9rQYpHXSkyC6y2itLCJEuYWSAQ1ANuTk4UAvmD"
  },
  {
    "id": 333,
    "name": "western hat",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRN3721on2peWTjj1p6ujGC5ts86BBkoFC15uvkhDwW6N"
  },
  {
    "id": 334,
    "name": "verified mask",
    "trim": "gold",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmNpeLTjex1m5ybgMHx4ZzSDLDFHdjo8XYsGKXjKnh28Fx"
  },
  {
    "id": 335,
    "name": "tie-dye tee",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdLzKiHfBs7VPbZSLCHCD3E9SQCaL6KNvKkTebAsxKe1o"
  },
  {
    "id": 336,
    "name": "tie-dye swirl tee",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPMJAeNdrXZhCVLpALDUJtti6ytR8wNo8rTE2xfsbhCQk"
  },
  {
    "id": 337,
    "name": "emotional longsleeve",
    "trim": "super nova",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmTa1W1BE3Zcj65cgtLnJuHBtzPmcoDpVrsZPcs1RWz9Pe"
  },
  {
    "id": 338,
    "name": "emotional longsleeve",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdWwssteFu8f25SomrvMTfTEPjCBHVo1eUL8hksFa8WSC"
  },
  {
    "id": 339,
    "name": "bomber jacket",
    "trim": "fiesta",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZhLCjeQtuGG29HRbVtosP2rkjkYdQdXy9enWvfSWbTJP"
  },
  {
    "id": 340,
    "name": "collared zip",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmbKUsFKfW2apX67YRSv1vi7mkhK92ZRbzACWXFYZ3etRd"
  },
  {
    "id": 341,
    "name": "collared zip",
    "trim": "brown",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmW5Z6LMAmuo9tdYjTfDNgzaoLVkLs9BTqnfpDzLAr6Tb2"
  },
  {
    "id": 342,
    "name": "spotted longsleeve tee",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPBVxmyceqj7wR35XXq5sK6Gwea7qioNshAxCoY4vXBDw"
  },
  {
    "id": 343,
    "name": "happy logo tee",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmQy3AzaGHYCTav8aAqFhLKkhkdjVJxe2ZvoXyuwwSF7Cu"
  },
  {
    "id": 344,
    "name": "poop logo tee",
    "trim": "yellow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmX7efJGii7zXy4M8HJjRod9AyPU8e6qmktucNEM7yfXW3"
  },
  {
    "id": 345,
    "name": "leopard hoodie",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSHwMytWq6ZV36QxpAHEbikoS24fZBqieHcohSCH5XvYn"
  },
  {
    "id": 346,
    "name": "polka dot t-shirt",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmah4vqgF6zJYc6Urv4iZJ1wDHFDrUDabK6dCj3Z2q91Qc"
  },
  {
    "id": 347,
    "name": "half-zip hoodie",
    "trim": "magic garden",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmUwCLd9XAokmfXY3MzwC65KRpQjtHHtpyxhx6bo62yKzJ"
  },
  {
    "id": 348,
    "name": "flamenco dress",
    "trim": "fiesta",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmQjQyBnc8MWuMG1ynQZe9hNhzuCVFTpEd9ayS49WRkrmk"
  },
  {
    "id": 349,
    "name": "casual dress",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZbQzLmwyYBY8vB8ChAXF2Nzc6eYohTCQrTXih1TS4ZCG"
  },
  {
    "id": 350,
    "name": "happy logo tee",
    "trim": "black",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmf96oyJz1KXAqJCfTP9u5ySG4hikTQqAcbuiGXspNcvtP"
  },
  {
    "id": 351,
    "name": "happy logo tee",
    "trim": "gumball",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmVf5kPsYhv7rC5e9iFCHA4Fn8oEkC8L4YVifENfsGzfND"
  },
  {
    "id": 352,
    "name": "happy logo tee",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSQRB5QjhhbB7UUJfRVjkdUDhUchQ5K27w77Uc2ByNNrW"
  },
  {
    "id": 353,
    "name": "happy logo tee",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qme4QJh3KSHHaDKxDb1EzMjudhamDHeLtjea5utNQ4gdwy"
  },
  {
    "id": 354,
    "name": "happy logo tee",
    "trim": "green",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPJQHUepYpziLo5Yj41k1Jss8rD8Lftx7VJq45Mzjy6RL"
  },
  {
    "id": 355,
    "name": "collared sweater",
    "trim": "disco",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPHNNW3hAadKu7pBHxc7XUqHJrBKD5k2L6whfLCDsy8qy"
  },
  {
    "id": 356,
    "name": "verified hoodie",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmcyorocs9Kkgwx42C3qw6wzmtUCec7kBEtVegQHapYKDo"
  },
  {
    "id": 357,
    "name": "big city longsleeve",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "multi",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmapHQkCbd9CBQPxkF7sgwVkdUmVczDU5YqEyztCN4j1wB"
  },
  {
    "id": 358,
    "name": "doodlebot torso",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "chest",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmY39XSU53ihhvzMsuprNY14tbEqEVDFH3kDcxymmaCKPd"
  },
  {
    "id": 359,
    "name": "tp top",
    "trim": "white",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "multi",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYYqdJmTa5rS6JFDJAoatSkiN2sbpWVBTwzSMgS2snSsW"
  },
  {
    "id": 360,
    "name": "introvert hoodie",
    "trim": "gumball",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "multi",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWPmsoXceQgrpp6gCtVfhEhjJqRxx1kB3pzYsXmBUfh34"
  },
  {
    "id": 361,
    "name": "hideout hoodie",
    "trim": "tokyo pink",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "multi",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmUZp1nA4oHGCTwwa18817bt6TBaSoJHXvMWJ8kPZtAXoK"
  },
  {
    "id": 362,
    "name": "collared tee",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRGfrSL6ZiPk6GXGyTj3Msw6VpQM3kZgdNfZKkyn21npA"
  },
  {
    "id": 363,
    "name": "collared tee",
    "trim": "super nova",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWFW1KrjWQinXpCQCHVb7KmEauuRcHoW5fHZKa32Wrrvv"
  },
  {
    "id": 364,
    "name": "tennis tee",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdJSUgzopoG8TH2bHhnA8u1Q4XyNgGCzwmdUmXw8T67Bi"
  },
  {
    "id": 365,
    "name": "varsity hoodie",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZc3WMrF6U4R948vsdynnDBCZChJLeMGBkk3WyaHyf2X2"
  },
  {
    "id": 366,
    "name": "spiked leather jacket",
    "trim": "black",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWzvZ1gCHNR7X8EimFzMtuLTEWfRV1JQGVDik3xmf5YEX"
  },
  {
    "id": 367,
    "name": "spiked leather jacket",
    "trim": "gold",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmX3Jnjr5KiMfLeRtjxsVR9Vt45eciQxgZYg45iaJGsVEc"
  },
  {
    "id": 368,
    "name": "foam party blouse",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZteJ8D6B5GMrdbqnhkUpPUbJ8omFjt93nGfSxrrQFiEk"
  },
  {
    "id": 369,
    "name": "tactical puffer",
    "trim": "coastal classic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmawGk9HEBLagD6WWj88QWUUeM7wMB8fspH1MR7qoreNgF"
  },
  {
    "id": 370,
    "name": "tactical puffer",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZCt1zQSYtqkYksTeyRxwxXv2oaMGsjqCSH8E2ZTdEKeB"
  },
  {
    "id": 371,
    "name": "cardigan",
    "trim": "coastal classic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmXMcSDJLDdDW3q3jaS1T5feSdfEtKwXSYbc69VBDaacp3"
  },
  {
    "id": 372,
    "name": "patchwork tee",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYjyhg21pND46HdZQqE8prELTdKjc629YXpKv9JHGhkWB"
  },
  {
    "id": 373,
    "name": "patchwork tee",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmeKoSt5jhsdTiekcyemM5UmWsvSbTAkyUJMcvTFriZr4N"
  },
  {
    "id": 374,
    "name": "denim jacket",
    "trim": "sky blue",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcxLnMCcXmHgh8xfQVWt12eAQamTtJPt97ghX2PWgC1yj"
  },
  {
    "id": 375,
    "name": "sticky note tee",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmTFG5Rb5AraAuAzENac9ALmpECiESRSBZoR5FsTbt13dX"
  },
  {
    "id": 376,
    "name": "sticky note tee",
    "trim": "yellow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmRpkNLc2TmfiRDLWjwJUy6qMJLZMRqSSoj9Uu1hNAGojG"
  },
  {
    "id": 377,
    "name": "sticky note tee",
    "trim": "green",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWSr4saP6izL3hk8xPDUnXxXZhNuqKCagjXtuXdKVrV98"
  },
  {
    "id": 378,
    "name": "sticky note tee",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmR7RzCfY12f3Z9kdAGFVeZ4xfSZytXq2GqDkico7oKjPL"
  },
  {
    "id": 379,
    "name": "sky puffer",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmPBPVwmkJV2ptKjnwoAfap8QZf3hRKdddevJBwUQdb2um"
  },
  {
    "id": 380,
    "name": "washed up tee",
    "trim": "beige",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmYAhEMwLVMKXRfkEHtS4Y3FG7e8Wa4yMgZp1peRiRTqfJ"
  },
  {
    "id": 381,
    "name": "lava lamp jumper",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "chest",
    "layer": "mid layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcLBafWwZyFz3iJ7HfjJkg8dPcK6SnNiDBczicqazwV1q"
  },
  {
    "id": 382,
    "name": "denim jacket",
    "trim": "black",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmcaHK7ruFge6dwGbJQ7jZyt9Pkx9r2bTh124DeF1oHV8y"
  },
  {
    "id": 383,
    "name": "trench coat",
    "trim": "brown",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmaEAp3dPFDa2cMZW79Er76GfY64E4uSLwcCPoaSRzihRz"
  },
  {
    "id": 384,
    "name": "frosty cardigan",
    "trim": "white",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmdrQbeS8SCa7wQEzekpCPta6bQpFUfXbsGFapZJiB8sVU"
  },
  {
    "id": 385,
    "name": "cashed out shorts",
    "trim": "green",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUT3LgQmKVVGx3vZEFn26BKFfZuGHa8bpxyVTH17xjPt3"
  },
  {
    "id": 386,
    "name": "shorts",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbvGpc21e9BbeZYTBboD3o1wwLLenpgzhsa5x5SEHF4xd"
  },
  {
    "id": 387,
    "name": "heart bloomers",
    "trim": "red",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmPdfWjoW979i3MH1MrHeg6JUv9VfNuqwFSUpdc9Zctpd7"
  },
  {
    "id": 388,
    "name": "smiley bloomers",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmT8YebgEvrnqFZ93G9nFq4wo1v565cmuzWGZqzC4ADPay"
  },
  {
    "id": 389,
    "name": "puffer drip shorts",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmS8BfN46SLHRZLaqNLQUGCfPZygpfQTEGJE4FkgX1xpEG"
  },
  {
    "id": 390,
    "name": "swim gear",
    "trim": "multi-colored",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "multi",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmXGewtCRFsrKn6SSwSE2uPr9FJzjsWddAL5h1HiwoUo2d"
  },
  {
    "id": 391,
    "name": "alchemist's pants",
    "trim": "white",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmProvPBUGC93qGoRKx4wK6mdE2pK7VDeiXUvLHUFgbtyc"
  },
  {
    "id": 392,
    "name": "fish bag pants",
    "trim": "orange",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmcfqEbY8RyiQsHVSMoYVZ7Gg1Ft4hwPVCfA8w7iuLe87J"
  },
  {
    "id": 393,
    "name": "dino suit",
    "trim": "green",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "multi",
    "layer": "",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmV4EcaJdKPqP6r5fMAD7qYzW4JjNjSTosSguWT4LXPW9M"
  },
  {
    "id": 394,
    "name": "frosty pants",
    "trim": "white",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmNQiEJ3wp5tTWom9K8JXQd6x6qEYH6zj3xAUuNoafZSSb"
  },
  {
    "id": 395,
    "name": "polka dot yoga pants",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUqZgAaNQojfSw43riHmHE8b3DV9s9kcAkUfVNVuwNa2s"
  },
  {
    "id": 396,
    "name": "jorts",
    "trim": "sky blue",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmcomV62umUiWjgL2PmeRLhovwmhCMLsriZZfa4Nnpas7T"
  },
  {
    "id": 397,
    "name": "ripped jeans",
    "trim": "sky blue",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmPiQWQveRXTWojp6NgZozB9pTqiBjDgvtFG6k2SysbFxW"
  },
  {
    "id": 398,
    "name": "puffer joggers",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmNjcx53CxC9yM9yz9jSEe8cE2SYN4g5kN7mXK4DZt7oSb"
  },
  {
    "id": 399,
    "name": "puffer joggers",
    "trim": "coastal classic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZJY4yyzsUSYMDUy8wnQda9WSeAVZyKV3N8L6yyB82Rs8"
  },
  {
    "id": 400,
    "name": "spotted overalls",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "multi",
    "layer": "",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmR2K6g3rPc5dVAgdGoqqxaHUCfzs7FJP6LgQdRjX3Wqda"
  },
  {
    "id": 401,
    "name": "spotted overalls",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "multi",
    "layer": "",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmNYj2xxSmPTrKDjhgmbneNMFvYvncj1yFHGyKEyiSobPS"
  },
  {
    "id": 402,
    "name": "lit pants",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmfJ44mNC9ebNvPVVhhDQ56bfXqKA1AzJyibUqrQTDNLi5"
  },
  {
    "id": 403,
    "name": "lazy overalls",
    "trim": "sky blue",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdxKFZsFpuZ54b41KzDbFDDCniRkzvsXLXPzZxfGxBMMU"
  },
  {
    "id": 404,
    "name": "lazy overalls",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmR5Lg1jNqwKmk52LrwhkLBQTmcxQt3DBsX8pzvDmBke58"
  },
  {
    "id": 405,
    "name": "sunset trunks",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZ5Q7QvRZSCqhT8vyEk4XAr2h25a2Yuzrqj446ffU7mQi"
  },
  {
    "id": 406,
    "name": "thick stripe trousers",
    "trim": "green",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmU7G48PWsi7PSXT9vqni5Qg6s9piEHzGdoytJLqNAsayc"
  },
  {
    "id": 407,
    "name": "color block trousers",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmRB6afewFGNpFRanK2m3p2rREF4kSqfteWixpYFvUYZep"
  },
  {
    "id": 408,
    "name": "color block trousers",
    "trim": "super nova",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmYftpwPkHfMCASHNU2xmWYnMuuTYq3NVyNJeJAiu3gwkq"
  },
  {
    "id": 409,
    "name": "striped bell-bottoms",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUZsLtgPhpDL94WqQKUa9Kvm2735t8fY67JakwbtAntgm"
  },
  {
    "id": 410,
    "name": "striped bell-bottoms",
    "trim": "yellow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmaWtQ7KVYd3Ex1xgkGjDoGQYmzfN9JTmWSZB7N6pvdKbG"
  },
  {
    "id": 411,
    "name": "slouchy sweatpants",
    "trim": "orange",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmYskqGL576dyBTJTVMFDoJTFLFxkBsDx9EogQtZnuqcgq"
  },
  {
    "id": 412,
    "name": "slouchy sweatpants",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmeRCQA5srDUowzVhUNzPnjxHCaRpZn9tMkjAQBJvw1ta2"
  },
  {
    "id": 413,
    "name": "parachute pants",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmQnXx5CUiExMMmynpGvBWBc2yHRAQ1pQ3BCN7MniggVU1"
  },
  {
    "id": 414,
    "name": "parachute pants",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmPadfpgjAP1cUhh9afxK6XXeHcNuQFXKsF7kFVb9mY7X9"
  },
  {
    "id": 415,
    "name": "royal cape",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmVhu7DSLyPYJ696ZFewNuYHo4MKhPWhBaogJcyudNdjHC"
  },
  {
    "id": 416,
    "name": "royal cape",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "back",
    "layer": "accessory",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmbybneAKbCvhNpNLXRwH9unPvycH2ioWpLH76ha1vLhHt"
  },
  {
    "id": 417,
    "name": "breakfast shorts",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmW3m2srUKfn4AwTAqyef6GGsJvYzv4fZjQoHNo19MxTnT"
  },
  {
    "id": 418,
    "name": "breakfast shorts",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdE8UgHKN2a8WxvvAedfASui8xD8bssmzrCbpipbW1bWt"
  },
  {
    "id": 419,
    "name": "breakfast shorts",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUvncQ1CrW5H83xG2f55J3rYpED5Mkyq2ykt56hzMnJ5F"
  },
  {
    "id": 420,
    "name": "paw pants",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUNP84CknGqRY7HxNRqFWgGSWAoMDU3Vtj6YFpLDrXN5d"
  },
  {
    "id": 421,
    "name": "paw pants",
    "trim": "holographic",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "legs",
    "layer": "base layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmV4KE7KUCsZorNmZoc2uGgnfRSDi5oSaf9EBMrJ9hhqKz"
  },
  {
    "id": 422,
    "name": "chunky loafers",
    "trim": "brown",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmewPDNpptV12wWepZeygqVHGJuAr2oeG7hjsU7WFh1RfH"
  },
  {
    "id": 423,
    "name": "chunky loafers",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUxei2X55uj9hhjF2huJaS4udreGuaWtAxfTpwWe5qgPN"
  },
  {
    "id": 424,
    "name": "trooper boots",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmXh1UbepA8LrwnaBEuB5YzpXeiVkTUAvkmE6it6yatvHA"
  },
  {
    "id": 425,
    "name": "trooper boots",
    "trim": "brown",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbegrQP96FddaGezbgncTYxLhkcR2bLrRvJe4yqfLbCmq"
  },
  {
    "id": 426,
    "name": "sheep slippers",
    "trim": "white",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmXypfyULyMUPmnXpPY1TtwD4xVCM9dnpBCZXpoc2tZ96w"
  },
  {
    "id": 427,
    "name": "rainbow puke shoes",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmYRxPPPobJJ9UZGeAmn1qLmhh85z8GTW9rjp8z6o3AaVh"
  },
  {
    "id": 428,
    "name": "running shoes",
    "trim": "yellow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmdfjjdd8NSxLfFSFfknoazBNS6EK9yy4XM6TMzkkYRwPM"
  },
  {
    "id": 429,
    "name": "flip flops",
    "trim": "tokyo pink",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmPe7jQFHtmNHi62FX7aXgBesc2AP1QthbFdfxiYTZt3EB"
  },
  {
    "id": 430,
    "name": "piñata boots",
    "trim": "rainbow",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmbk12e6PThnESCUDaaxCmr45gaohYpcQv5bwowterWjhA"
  },
  {
    "id": 431,
    "name": "cleats",
    "trim": "super nova",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmTVL4H2RaYxH5Nh5PqsCdW8Gf1Bxo9eodQ8R7JbQGbzro"
  },
  {
    "id": 432,
    "name": "daisy platforms",
    "trim": "yellow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmWAkfce1RWqFFV7uMsipZNmChFnC3YBcmNJ1mASEkje1Q"
  },
  {
    "id": 433,
    "name": "tennis shoes",
    "trim": "super nova",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUx4eU1hgzyv3WKFqx3nFY5ZX3jJzRaTw4H1Kk1H4eGnB"
  },
  {
    "id": 434,
    "name": "tennis shoes",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbmaMbU8dTe6KNeQFBqgPsdUFEwE77UXRayyAKZRvrswm"
  },
  {
    "id": 435,
    "name": "zip clogs",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmcHkvqTh1TkS71bq3B7BmDRQkkhU4uu2kxF4aBGvufpSM"
  },
  {
    "id": 436,
    "name": "zip clogs",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmaQSFV61yTTwUEM6QH8tgnKCB6Kfg1Csza6NpqiusVkEj"
  },
  {
    "id": 437,
    "name": "fuzzy slip-ons",
    "trim": "purple",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZ92XhpLedriXE7kyqr199FK6t6CLUuP6jtVyKmzSBNwf"
  },
  {
    "id": 438,
    "name": "glitter tank shoes",
    "trim": "",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmay9L3pFmqpHvpyAGibCDS4yM378Eo7r2sS7JsF2f84Vy"
  },
  {
    "id": 439,
    "name": "mercury fliers",
    "trim": "blue",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmSX1cyi3ZycV9GbYYdfZ133ABpzYobzxZo1CDW2mSCpac"
  },
  {
    "id": 440,
    "name": "rocket skis",
    "trim": "sherbert sunrise",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmWF3vNad69gVZZdXZMWAfezykPQvC3RxAW9kgZjugvxuZ"
  },
  {
    "id": 441,
    "name": "rocket skis",
    "trim": "super nova",
    "set": "Genesis Box",
    "set_type": "Grail",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmQ9H25bJfzRT9gRWm7TDAvMubxMkPjsvmhYs3KTh83M59"
  },
  {
    "id": 442,
    "name": "strappy sandals",
    "trim": "green",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbxyEcyHvqsRhNqkF1gdVYPNBp8bJSFBFMVWv5BMazXvX"
  },
  {
    "id": 443,
    "name": "strappy sandals",
    "trim": "fiesta",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmUnAgLuww2qF8o7veXWCH2Ye8LEyV3orvCK7JR42juM5L"
  },
  {
    "id": 444,
    "name": "leather wing tips",
    "trim": "brown",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmaLYB3WN6LyrZP87idTb3pGWn6i4UuvHkCNX3JLVF3b24"
  },
  {
    "id": 445,
    "name": "lion slippers",
    "trim": "yellow",
    "set": "Genesis Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmaEgVihA4KneHhgjqEs4FfKuPjYENqiHJerLncx97Xr9D"
  },
  {
    "id": 446,
    "name": "octopus shoes",
    "trim": "pink",
    "set": "Genesis Box",
    "set_type": "1:1",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbupteWtYdD2EZ1NiPWm3jzrYacrJ19Y6YuVu9tTj8r86"
  },
  {
    "id": 447,
    "name": "adidas sambas",
    "trim": "tan",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmcf3B7f1MmqNQzwZAokryhRpnnbQepxD3fLrrVVnN6gGF"
  },
  {
    "id": 448,
    "name": "adidas sambas",
    "trim": "purple",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmc7mRhcov8VQNXBJdPX9FtjRjpYRYs1c9Wg7rPF1rUa6g"
  },
  {
    "id": 449,
    "name": "adidas sambas",
    "trim": "yellow",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmdb98BimeKAPfpgikzimesT4yRzXRUdpZdfJBTkYf66yu"
  },
  {
    "id": 450,
    "name": "adidas sambas",
    "trim": "orange",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmbK2SQry6KG3mZxCWeTcGKsrh8Vu6b8G6oCj9DtmrtEMa"
  },
  {
    "id": 451,
    "name": "adidas sambas",
    "trim": "pink",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmNk6H1YGCKEnNhrHqkX8nGYrXHZ4u4S7yxim7Zx7BrpfK"
  },
  {
    "id": 452,
    "name": "adidas sambas",
    "trim": "red",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmSRNmWuJWLVc5SvwUHYFFa9XmQfiKUL9V9bLTy3hjtmYG"
  },
  {
    "id": 453,
    "name": "bbc space helmet",
    "trim": "holographic",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmbpj46p5YsE5Ze1mBo1k5xDbTWgxGh5vEkbGfgeqxPMKq"
  },
  {
    "id": 454,
    "name": "bbc varsity jacket",
    "trim": "sherbert sunrise",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmanvprFqqFMGyQzi6yDZQ6nHcS3rPWhshiA3MWmsRd7yr"
  },
  {
    "id": 455,
    "name": "icecream ripped jeans",
    "trim": "blue",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "legs",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZqX3HKFy5trihQ2FYt44AaKh7eS8tKscpcbEgjNUJFht"
  },
  {
    "id": 456,
    "name": "icecream cone head",
    "trim": "",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "head",
    "layer": "override",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmWNzj76yi6HUSb9dbnNnRktGcTYkHRxqWevNMh8jJXEWa"
  },
  {
    "id": 457,
    "name": "icecream tee & chain",
    "trim": "white",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qme87CjkzR4CUVtayAsZpfq4uYJmxu4mhzyEUgJwrbSodL"
  },
  {
    "id": 458,
    "name": "humanrace hoodie",
    "trim": "yellow",
    "set": "Pharrell Pack",
    "set_type": "Exclusive",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmXgGmSQirHjVkBZNrjj4KXdbjHkp9LY93Rvzv4aBCDQaR"
  },
  {
    "id": 459,
    "name": "adidas sambas",
    "trim": "green",
    "set": "Pharrell Pack",
    "set_type": "Grail",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmU8DGBP3WvVwNyfLz3TW5ouXrqvD9oqKPLFmdq71tJtyH"
  },
  {
    "id": 460,
    "name": "icecream skateboard",
    "trim": "",
    "set": "Pharrell Pack",
    "set_type": "Grail",
    "body_position": "hand",
    "layer": "scene",
    "plurality": "FALSE",
    "ipfs_hash_svg": "Qmb9NSyKZYK5BfMWU1NXr8zeimEXVtER5dZZTpLKZSPaTU"
  },
  {
    "id": 461,
    "name": "humanrace hoodie",
    "trim": "green",
    "set": "Pharrell Pack",
    "set_type": "Grail",
    "body_position": "chest",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmZ28jfrk5yjzzycrKKCyEa7y9hWemfx4iYQUEQqeT5S5i"
  },
  {
    "id": 580,
    "name": "splatter crocs",
    "trim": "rainbow",
    "set": "Crocs Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmaKfpG6s2h4H5i3jwHPjDJk1bYMKDVDQxaYr5iB3VKcRg"
  },
  {
    "id": 581,
    "name": "rainbow crocs",
    "trim": "rainbow",
    "set": "Crocs Box",
    "set_type": "Grail",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmdr2ybruzD7PvQKi527raTXLXsZEoUdS4Z8PhcoBQEmBk"
  },
  {
    "id": 582,
    "name": "sticky note crocs",
    "trim": "tokyo pink",
    "set": "Crocs Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmdQkiKcN5E7uPAB4K1YntviGr68NL6tE7ywdGXkmoLNZ8"
  },
  {
    "id": 583,
    "name": "crocs jersey",
    "trim": "tokyo pink",
    "set": "Crocs Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmWqSAv3EsLYaSryTo5yhJLgyuAEth7XioAwm7y4JgjrRr"
  },
  {
    "id": 584,
    "name": "holo crocs",
    "trim": "holographic",
    "set": "Crocs Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmdn58LyURkpxTwM6vqUccr1CFdtPQGq9fD1UDrfS4Jbbc"
  },
  {
    "id": 585,
    "name": "touch grass crocs",
    "trim": "green",
    "set": "Crocs Box",
    "set_type": "Grail",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmWKX9Jj1Fm6DavGgxtdsadMMAQ3M9K5YfugodSveR47Cp"
  },
  {
    "id": 586,
    "name": "hot rod crocs",
    "trim": "black",
    "set": "Crocs Box",
    "set_type": "Grail",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmWBUtHhynenk3JvEJ77aNiHbwU2i9EEF6n5Sk1n1GWB1m"
  },
  {
    "id": 587,
    "name": "fishy crocs",
    "trim": "yellow",
    "set": "Crocs Box",
    "set_type": "Grail",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmZknewEarSjZbjQcdkWRRMvgsPZQuQUpeEpXjLvtn27Xj"
  },
  {
    "id": 588,
    "name": "springtime crocs",
    "trim": "blue",
    "set": "Crocs Box",
    "set_type": "Exclusive",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "QmQKeN3QYU9s4rsnjMrvc8888pmJasvRMQWyCKDwrjWsE8"
  },
  {
    "id": 589,
    "name": "crocap",
    "trim": "green",
    "set": "Crocs Box",
    "set_type": "Grail",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmSubqfpDDn1EwkXcb1z4te2797eMB65CXUxCw6zMfL15W"
  },
  {
    "id": 590,
    "name": "crocap",
    "trim": "gold",
    "set": "Crocs Box",
    "set_type": "1:1",
    "body_position": "head",
    "layer": "outer layer",
    "plurality": "FALSE",
    "ipfs_hash_svg": "QmbYG1ttFacA5W1DQXoqZmxp7cEvPg61P8q24tLFJTaBxy"
  },
  {
    "id": 591,
    "name": "croc-ception",
    "trim": "green",
    "set": "Crocs Box",
    "set_type": "Grail",
    "body_position": "feet",
    "layer": "outer layer",
    "plurality": "TRUE",
    "ipfs_hash_svg": "Qmd9RUyMS3PdtgKcepW8mTFoJafLB3AbvAkBwjUfqWvQd7"
  }
]
